(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('activityResumoAnotacoes', ActivityResumoAnotacoes);

  function ActivityResumoAnotacoes() {
    return {
      restrict: 'E',
      controller: 'ResumoAnotacoesCtrl',
      templateUrl: 'views/painel_propriedade/_resumo_anotacoes.html',
      scope: {
        data: '<',
        tipo: '<'
      }
    };
  }

}());
